import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnamneseConfiguracaoListarComponent } from './anamnese-configuracao-listar.component';

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: AnamneseConfiguracaoListarComponent}
  ])],
  exports: [RouterModule]
})
export class AnamneseConfiguracaoListarRoutingModule { }
